const isCCNumberValidAmex = (cardNumber = '') => {
  const amexCardRegex = /^(?:3[47][0-9]{13})$/;
  return cardNumber.match(amexCardRegex);
};

const isCCNumberMasked = (cardNumber = '') => {
  const maskedRegex = /^xxxx[0-9]{4}$/i;
  return cardNumber.match(maskedRegex);
};

const isCCNumberValid = (value = '') => {
  const visaCardRegex = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
  const mcCardRegex = /^(?:5[1-5][0-9]{14})$/;
  const discCardRegex = /^6(?:011|22(?:1(?=[-]?(?:2[6-9]|[3-9]))|[2-8]|9(?=[-]?(?:[01]|2[0-5])))|4[4-9]\d|5\d\d)([-]?)\d{4}\1\d{4}\1\d{4}$/;

  return (
    isCCNumberValidAmex(value) ||
    isCCNumberMasked(value) ||
    value.match(visaCardRegex) ||
    value.match(mcCardRegex) ||
    value.match(discCardRegex)
  );
};

export { isCCNumberValidAmex, isCCNumberMasked, isCCNumberValid };



// WEBPACK FOOTER //
// ./src/components/Forms/Validations/ccNumberValidation.js